import { createPinia } from 'pinia';

export const pinia = createPinia();

export { useAlertStore } from './alert.module';
export { useAuthStore } from './authentication.module';
export { useApiStore } from './API.module';
export { useErrorStore } from './error.module';
export { usePaymentsStore } from './payments.module';
export { usePartnersStore } from './partners.module';
export { usePaymentLogsStore } from './paymentLogs.module';
export { useProfilesStore } from './profiles.module';